import {
  TextField,
  Button,
  DialogActions,
  ThemeProvider,
  Dialog,
  DialogTitle,
  DialogContent,
  Collapse,
  IconButton,
} from "@mui/material";
import React, { useMemo, useRef, useState } from "react";
import palette, { polylineColors } from "../../../../../../config/colorPalette";
import { clone, isEmpty, isNil } from "ramda";
import { getMuiTheme } from "../../../../../utils/utils";
import { Circle, MapContainer, Marker, Pane, Polygon, Polyline, TileLayer, useMap, useMapEvents } from "react-leaflet";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const ModalAreas = ({
  e,
  polylineDisplay,
  equipment,
  setEquipment,
  indexEquipment,
  useStyles,
  customCentroidIcon,
  customInclinometerIcon,
  customIcon,
  customShadowIcon,
  errors,
  setErrors,
  BootstrapButton,
  areasToggle,
  setAreasToggle,
  inclusionArea,
  setInclusionAreas,
  protectionPolygon,
  criticalPolygon,
  selectingCenter,
  setSelectingCenter,
  inclusionPoint,
  setInclusionPoint,
  inclusionRange,
  setInclusionRange,
  exclusionPoint,
  setExclusionPoint,
  selectingExclusion,
  setSelectingExclusion,
  exclusionRange,
  setExclusionRange,
  areasDefToggle,
  setAreasDefToggle,
  intl,
}) => {
  const theme = useMemo(() => getMuiTheme(), []);
  const [mapType] = useState("regular");
  const initializedRef = useRef(false);

  const AddCentroid = ({ onSelect }) => {
    useMapEvents({
      click(e) {
        onSelect([e.latlng.lat, e.latlng.lng]);
      },
    });

    return null;
  };

  const MyComponentSetView = ({ polyline }) => {
    const map = useMap();
    if (!initializedRef.current && !isEmpty(polyline) && !isNil(polyline[0].points) && !isEmpty(polyline[0].points)) {
      map.fitBounds(polyline[0].points);
      initializedRef.current = true;
    }
    return null;
  };

  const handleClose = (indexEquipment, areasToggle, setAreasToggle) => {
    let newAreaToggle = clone(areasToggle);
    newAreaToggle[indexEquipment] = !areasToggle[indexEquipment];
    setAreasToggle(newAreaToggle);
  };

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        maxWidth="lg"
        open={areasToggle[indexEquipment]}
        onClose={() => handleClose(indexEquipment, areasToggle, setAreasToggle)}
      >
        <DialogTitle style={{ fontSize: "x-large", color: palette.primary, fontWeight: "600" }}>
          {intl.formatMessage({ id: "inclusion.exclusion.areas" })}
        </DialogTitle>
        <DialogContent>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "20px",
              width: "100%",
              boxSizing: "border-box",
              overflowX: "hidden", // evita scroll horizontal
              alignItems: "flex-start",
            }}
          >
            <div
              style={{
                marginTop: "1%",
                flexDirection: "column",
                gap: "1rem",
                flex: "0 0 45%",
                display: "flex",
              }}
            >
              <h1
                onClick={() => {
                  let newAreaToggle = clone(areasDefToggle);
                  newAreaToggle[indexEquipment][0] = !areasDefToggle[indexEquipment][0];
                  setAreasDefToggle(newAreaToggle);
                }}
              >
                {intl.formatMessage({ id: "inclusion.areas" })}{" "}
                {areasDefToggle[indexEquipment][0] ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
              </h1>
              <Collapse in={areasDefToggle[indexEquipment][0]}>
                {isNil(selectingCenter) ||
                  (isEmpty(selectingCenter[indexEquipment]) && (
                    <div
                      key={"none"}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "0.5rem",
                        width: "100%",
                        marginTop: "1%",
                      }}
                    >
                      <IconButton
                        style={{ backgroundColor: palette.dividerLight, marginRight: "0.5%" }}
                        key={`add_inclusion`}
                        onClick={() => {
                          let newSc = clone(selectingCenter);
                          newSc[indexEquipment].push(false);
                          setSelectingCenter(newSc);

                          let iP = clone(inclusionPoint);
                          iP[indexEquipment].push(null);
                          setInclusionPoint(iP);

                          let iR = clone(inclusionRange);
                          iR[indexEquipment].push(100);
                          setInclusionRange(iR);
                        }}
                      >
                        <AddIcon sx={{ color: palette.primary }} />
                      </IconButton>
                    </div>
                  ))}
                {selectingCenter[indexEquipment].map((sc, scIndex) => (
                  <div
                    key={scIndex}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "0.5rem",
                      marginTop: "2%",
                      width: "100%",
                    }}
                  >
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: selectingCenter[indexEquipment][scIndex] ? palette.light : palette.primary,
                        color: "white",
                        margin: "0 0.2rem 0.8rem",
                        height: "10.5%",
                      }}
                      disabled={selectingCenter[indexEquipment][scIndex]}
                      onClick={() => {
                        //Elegir punto en el mapa
                        let newSc = clone(selectingCenter);
                        newSc[indexEquipment][scIndex] = !selectingCenter[indexEquipment][scIndex];
                        setSelectingCenter(newSc);
                      }}
                    >
                      {intl.formatMessage({ id: "put.center" })}
                    </Button>
                    <TextField
                      id={`range`}
                      style={{ margin: "0 0.2rem 0.8rem" }}
                      inputProps={{ min: 0 }}
                      value={inclusionRange[indexEquipment][scIndex]}
                      onChange={(e) => {
                        //set new range
                        let iR = clone(inclusionRange);
                        iR[indexEquipment][scIndex] = parseInt(e.target.value);
                        setInclusionRange(iR);
                      }}
                      error={errors[`range`] ? true : false}
                      variant="outlined"
                      label={intl.formatMessage({ id: "range" })}
                      required
                      type="number"
                    />
                    <DeleteForeverIcon
                      onClick={() => {
                        let newSc = clone(selectingCenter);
                        newSc[indexEquipment].splice(scIndex, 1);
                        setSelectingCenter(newSc);

                        let iP = clone(inclusionPoint);
                        iP[indexEquipment].splice(scIndex, 1);
                        setInclusionPoint(iP);

                        let iR = clone(inclusionRange);
                        iR[indexEquipment].splice(scIndex, 1);
                        setInclusionRange(iR);
                      }}
                      sx={{ color: palette.primary, marginTop: "1%", cursor: "pointer" }}
                    />
                    {scIndex === selectingCenter[indexEquipment].length - 1 && (
                      <IconButton
                        style={{ backgroundColor: palette.dividerLight, marginRight: "0.5%" }}
                        key={`add_inclusion`}
                        onClick={() => {
                          let newSc = clone(selectingCenter);
                          newSc[indexEquipment].push(false);
                          setSelectingCenter(newSc);

                          let iP = clone(inclusionPoint);
                          iP[indexEquipment].push(null);
                          setInclusionPoint(iP);

                          let iR = clone(inclusionRange);
                          iR[indexEquipment].push(100);
                          setInclusionRange(iR);
                        }}
                      >
                        <AddIcon sx={{ color: palette.primary }} />
                      </IconButton>
                    )}
                  </div>
                ))}
              </Collapse>
            </div>

            <div
              style={{
                marginTop: "1%",
                flexDirection: "column",
                gap: "1rem",
                flex: "0 0 45%",
                display: "flex",
              }}
            >
              <h1
                onClick={() => {
                  let newAreaToggle = clone(areasDefToggle);
                  newAreaToggle[indexEquipment][1] = !areasDefToggle[indexEquipment][1];
                  setAreasDefToggle(newAreaToggle);
                }}
              >
                {intl.formatMessage({ id: "exclusion.areas" })}{" "}
                {areasDefToggle[indexEquipment][1] ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
              </h1>
              <Collapse in={areasDefToggle[indexEquipment][1]}>
                {(isNil(selectingExclusion[indexEquipment]) || isEmpty(selectingExclusion[indexEquipment])) && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "0.5rem",
                      marginTop: "2%",
                      width: "100%",
                    }}
                  >
                    <IconButton
                      style={{ backgroundColor: palette.dividerLight, marginRight: "0.5%" }}
                      key={`add_exclusion`}
                      onClick={() => {
                        let newSc = clone(selectingExclusion);
                        newSc[indexEquipment].push(false);
                        setSelectingExclusion(newSc);

                        let iP = clone(exclusionPoint);
                        iP[indexEquipment].push(null);
                        setExclusionPoint(iP);

                        let iR = clone(exclusionRange);
                        iR[indexEquipment].push(100);
                        setExclusionRange(iR);
                      }}
                    >
                      <AddIcon sx={{ color: palette.primary }} />
                    </IconButton>
                  </div>
                )}
                {selectingExclusion[indexEquipment].map((se, seIndex) => (
                  <div
                    key={seIndex}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "0.5rem",
                      marginTop: "2%",
                      width: "100%",
                    }}
                  >
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: selectingExclusion[indexEquipment][seIndex] ? palette.light : palette.primary,
                        color: "white",
                        margin: "0 0.2rem 0.8rem",
                        height: "10.5%",
                      }}
                      disabled={selectingExclusion[indexEquipment][seIndex]}
                      onClick={() => {
                        let newSe = clone(selectingExclusion);
                        newSe[indexEquipment][seIndex] = !selectingExclusion[indexEquipment][seIndex];
                        setSelectingExclusion(newSe);
                      }}
                    >
                      {intl.formatMessage({ id: "put.center" })}
                    </Button>
                    <TextField
                      id={`range`}
                      style={{ margin: "0 0.2rem 0.8rem" }}
                      inputProps={{ min: 0 }}
                      value={exclusionRange[indexEquipment][seIndex]}
                      onChange={(e) => {
                        let eR = clone(exclusionRange);
                        eR[indexEquipment][seIndex] = parseInt(e.target.value);
                        setExclusionRange(eR);
                      }}
                      error={errors[`range`] ? true : false}
                      variant="outlined"
                      label={intl.formatMessage({ id: "range" })}
                      required
                      type="number"
                    />
                    <DeleteForeverIcon
                      onClick={() => {
                        let newSc = clone(selectingExclusion);
                        newSc[indexEquipment].splice(seIndex, 1);
                        setSelectingExclusion(newSc);

                        let eP = clone(exclusionPoint);
                        eP[indexEquipment].splice(seIndex, 1);
                        setExclusionPoint(eP);

                        let eR = clone(exclusionRange);
                        eR[indexEquipment].splice(seIndex, 1);
                        setExclusionRange(eR);
                      }}
                      sx={{ color: palette.primary, marginTop: "1%", cursor: "pointer" }}
                    />
                    {seIndex === selectingExclusion[indexEquipment].length - 1 && (
                      <IconButton
                        style={{ backgroundColor: palette.dividerLight, marginRight: "0.5%" }}
                        key={`add_exclusion`}
                        onClick={() => {
                          let newSc = clone(selectingExclusion);
                          newSc[indexEquipment].push(false);
                          setSelectingExclusion(newSc);

                          let iP = clone(exclusionPoint);
                          iP[indexEquipment].push(null);
                          setExclusionPoint(iP);

                          let iR = clone(exclusionRange);
                          iR[indexEquipment].push(100);
                          setExclusionRange(iR);
                        }}
                      >
                        <AddIcon sx={{ color: palette.primary }} />
                      </IconButton>
                    )}
                  </div>
                ))}
              </Collapse>
            </div>
          </div>

          {/**tiene que ser un for con collapses por cada grupo de cables en caso de que no haya para compatir */}
          {/** se puede pinchar en mapa para guardar el punto y luego campo donde poner radio */}
          <MapContainer
            id="map-AREA-id"
            center={[43, 0]}
            zoom={5}
            style={{ height: "60vh", width: "110vh" }}
            rotateControl={false}
          >
            <TileLayer
              attribution={window.RUNTIME_CONFIG.IS_ONLINE ? "Google Maps" : "OpenStreetMap"}
              url={window.RUNTIME_CONFIG.MAP_TYPES.find((type) => type.value === mapType).tileLayer}
              maxZoom={20}
              subdomains={["mt0", "mt1", "mt2", "mt3"]}
            />
            <Pane name="polygonsPane" style={{ zIndex: 400 }} />
            <Pane name="linesPane" style={{ zIndex: 500 }} />

            <MyComponentSetView polyline={polylineDisplay} />
            {selectingCenter[indexEquipment].map((inclusion, inclusionIndex) => (
              <>
                {inclusion && (
                  <AddCentroid
                    onSelect={(coords) => {
                      let iP = clone(inclusionPoint);
                      iP[indexEquipment][inclusionIndex] = coords;
                      setInclusionPoint(iP);
                      let newSc = clone(selectingCenter);
                      newSc[indexEquipment][inclusionIndex] = false;
                      setSelectingCenter(newSc);
                    }}
                  />
                )}
                {!isNil(inclusionPoint[indexEquipment][inclusionIndex]) && (
                  <>
                    <Marker
                      position={
                        !isNil(inclusionPoint[indexEquipment][inclusionIndex]) &&
                        inclusionPoint[indexEquipment][inclusionIndex]
                      }
                      icon={customCentroidIcon}
                    />
                    <Circle
                      center={inclusionPoint[indexEquipment][inclusionIndex]}
                      radius={inclusionRange[indexEquipment][inclusionIndex]}
                      pathOptions={{ color: "red" }}
                    />
                  </>
                )}
              </>
            ))}
            {selectingExclusion[indexEquipment].map((exclusion, exclusionIndex) => (
              <>
                {exclusion && (
                  <AddCentroid
                    onSelect={(coords) => {
                      let eP = clone(exclusionPoint);
                      eP[indexEquipment][exclusionIndex] = coords;
                      setExclusionPoint(eP);
                      let newSe = clone(selectingExclusion);
                      newSe[indexEquipment][exclusionIndex] = false;
                      setSelectingExclusion(newSe);
                    }}
                  />
                )}
                {!isNil(exclusionPoint[indexEquipment][exclusionIndex]) && (
                  <>
                    <Marker
                      position={
                        !isNil(exclusionPoint[indexEquipment][exclusionIndex]) &&
                        exclusionPoint[indexEquipment][exclusionIndex]
                      }
                      icon={customCentroidIcon}
                    />
                    <Circle
                      center={exclusionPoint[indexEquipment][exclusionIndex]}
                      radius={exclusionRange[indexEquipment][exclusionIndex]}
                      pathOptions={{ color: "white" }}
                    />
                  </>
                )}
              </>
            ))}

            {!isNil(criticalPolygon) &&
              !isEmpty(criticalPolygon) &&
              criticalPolygon.map((poly, polyIndex) => (
                <Polygon positions={poly} pane="polygonsPane" key={`crit${polyIndex}`} pathOptions={{ color: "red" }} />
              ))}
            {!isNil(protectionPolygon) &&
              !isEmpty(protectionPolygon) &&
              protectionPolygon.map((poly, polyIndex) => (
                <Polygon
                  positions={poly}
                  pane="polygonsPane"
                  key={`prot${polyIndex}`}
                  pathOptions={{ color: "green" }}
                />
              ))}
            {polylineDisplay.length > 0 &&
              polylineDisplay.map((polyline, index) => {
                if (polyline.equipment_type !== e.equipmentType) return null;
                // eslint-disable-next-line array-callback-return
                return polyline.points.map((point, indice) => {
                  if (indice === 0 || polyline.must_graph_points.indexOf(indice) === 0) return null;
                  if (polyline.must_graph_points.includes(indice)) {
                    const previousIndex = polyline.must_graph_points[polyline.must_graph_points.indexOf(indice) - 1];
                    const center = [
                      [
                        polylineDisplay[index].points[previousIndex].lat,
                        polylineDisplay[index].points[previousIndex].lng,
                      ],
                      [point.lat, point.lng],
                    ];
                    return (
                      <Polyline
                        key={indice + "_" + index}
                        color={polylineColors[index]}
                        positions={center}
                        weight={5}
                      />
                    );
                  }
                });
              })}
          </MapContainer>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            style={{ backgroundColor: palette.secondary, color: "white" }}
            onClick={() => handleClose(indexEquipment, areasToggle, setAreasToggle)}
          >
            {intl.formatMessage({ id: "accept" })}
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};
export default ModalAreas;
